/**
 * Format price with thousands separators (e.g. 1,000).
 */
export function formatPrice(price: number | undefined | null, currency: string = 'AED'): string {
  if (price == null || Number.isNaN(Number(price))) return '—';
  return `${currency} ${Number(price).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
}
